import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

export interface DropdownMenuItem {
  id: string;
  title: string;
  url?: string; // navigate to this url when clicked
  separator?: boolean; // display a separator above
}

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
})
export class DropdownMenuComponent {
  @Input({ required: true }) label: string | null | undefined;
  @Input({ required: true }) items: DropdownMenuItem[];
  @Output() clicked = new EventEmitter<DropdownMenuItem>();

  isOpen = false;

  constructor(private router: Router) {}

  trackBy(index: number, item: DropdownMenuItem) {
    return item.id;
  }

  async onItemClicked(item: DropdownMenuItem) {
    this.clicked.emit(item);
    if (item.url && item.url.startsWith('http')) {
      window.location.href = item.url;
    } else if (item.url) {
      await this.router.navigateByUrl(item.url);
    }
  }
}
